import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { RoleInterface } from '../../Roles/Interfaces';

export default class CreateRoleForm {
  public name: string = '';
  public department: string = '';
  public extendedRoles: RoleInterface[] = [];
  public selectedScopes: string[] = [];
  public copyPermissions: boolean;

  public rules: { [key: string]: FormValidationFunction[] } = {
    roleNameRules: [
      (v: string) => !!v || 'Roles have to have a name',
      (v: string) => v.length >= 3 || 'Role name must be at least 3 characters',
    ],
    roleRules: [
      (v: string) => !!v || 'You have to select a role',
    ],
    department: [
      (v: string) => !!v || 'You have to select a department',
    ],
  };
}
